<iframe aria-label="Arc widget" *ngIf="loading == false" [cacheSrc]="getIframeSrc(src, param)" width="{{width}}" height="{{height}}"></iframe>
